module.exports = __webpack_public_path__ + "img/icon.5a6def61.png";